import styled from 'styled-components';

export default {
  Overlay: styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(21, 16, 53, 0.8);
    z-index: 1003;
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  Modal: styled.div<{ width: number }>`
    padding: 0 8px;
    width: 100%;
    max-width: ${(props) => props.width || 400}px;
    z-index: 1000;

    @media screen and (max-width: 720px) {
      bottom: 0;
      left: 0;
      right: 0;
      max-width: 100%;
      width: 100%;
      padding: 0;
      border-radius: 12px 12px 0px 0px;
      overflow: hidden;
    }
  `,

  Container: styled.div`
    position: relative;
    overflow: hidden;
    padding: 16px;
    background: #fff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: 12px;

    @media screen and (max-width: 720px) {
      border-radius: 12px 12px 0px 0px;
    }
  `,

  Close: styled.div`
    position: absolute;
    top: 16px;
    right: 22px;
    opacity: 1;
    line-height: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;

    svg {
      fill: black;
    }

    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  `,
};
